import { FeeLadderType } from "../enums/global.enums";

export function feeLadderTypePipe(value: string) {
    switch (value) {
        case FeeLadderType.All: return "Tất cả";
        case FeeLadderType.IncludeEnviromentFee: return "Giá tiền đã bao gồm phí bảo vệ môi trường";
        case FeeLadderType.NotIncludeTaxFee: return "Không bao gồm thuế phí";
    }
    return "";
}

export const FEE_LADDER_TYPES = [
    FeeLadderType.IncludeEnviromentFee,
    FeeLadderType.NotIncludeTaxFee,
];
